package org.ksdfv.thelema.audio

import org.ksdfv.thelema.fs.IFile
import kotlin.native.concurrent.ThreadLocal

/** @author zeganstyl */
@ThreadLocal
object AL: IAL {
    lateinit var proxy: IAL

    override fun newAudioDevice(samplingRate: Int, channelsNum: Int): IAudioDevice =
        proxy.newAudioDevice(samplingRate, channelsNum)

    override fun newAudioRecorder(samplingRate: Int, isMono: Boolean): IAudioRecorder =
        proxy.newAudioRecorder(samplingRate, isMono)

    override fun newSound(file: IFile): ISound =
        proxy.newSound(file)

    override fun newMusic(file: IFile): IMusic =
        proxy.newMusic(file)

    override fun getVersion(param: Int): String =
        proxy.getVersion(param)

    override fun update() =
        proxy.update()

    override fun destroy() =
        proxy.destroy()
}